import {
  Card,
  CardContent,
  Chip,
  Col,
  Flex,
  Heading,
  Icon,
  Icons,
  Paragraph,
  Row,
} from "@ir/ui";

export interface BrandDetailsStatsProps {
  brandName: string;
  brandKey: string;
}

export const BrandDetailsStats = ({
  brandName,
  brandKey,
}: BrandDetailsStatsProps) => {
  return (
    <Row className="mb-4">
      <Col span={6}>
        <Card className="bg-white" variant="outlined" shadow>
          <CardContent>
            <Paragraph className="text-grey-500 font-regular m-0">
              Name
            </Paragraph>
            <Heading level={4} className="text-primary font-bold m-0">
              {brandName || "-"}
            </Heading>
          </CardContent>
        </Card>
      </Col>
      <Col span={6}>
        <Card className="bg-white" variant="outlined" shadow>
          <CardContent>
            <Flex align="center" justifyContent="space-between">
              <Paragraph className="text-grey-500 font-regular m-0">
                Key
              </Paragraph>
              <Chip
                onClick={() => {
                  navigator.clipboard.writeText(brandKey);
                }}
                htmlTitle="Copy Key"
                size="medium"
                color="grey"
                borderless
                shape="square"
                icon={<Icon size="small" name={Icons.Copy} />}
              />
            </Flex>
            <Heading level={4} className="text-primary font-bold m-0">
              {brandKey || "-"}
            </Heading>
          </CardContent>
        </Card>
      </Col>
    </Row>
  );
};
